import { render, staticRenderFns } from "./historial.vue?vue&type=template&id=886a00e8&scoped=true"
import script from "./historial.vue?vue&type=script&lang=js"
export * from "./historial.vue?vue&type=script&lang=js"
import style0 from "./historial.vue?vue&type=style&index=0&id=886a00e8&prod&scoped=true&lang=css"
import style1 from "./historial.vue?vue&type=style&index=1&id=886a00e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886a00e8",
  null
  
)

export default component.exports